import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgBreakdown = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_4125_13973)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M22.4996 5.06088H1.49962C0.982125 5.06088 0.5 4.98247 0.5 5.49997C0.5 6.01747 0.982125 5.93588 1.49962 5.93588H22.4996C23.0171 5.93588 23.5 6.0175 23.5 5.5C23.5 4.9825 23.0171 5.06088 22.4996 5.06088ZM17.9996 11.0616H5.99962C5.48212 11.0616 5 10.9825 5 11.5C5 12.0175 5.48212 11.9366 5.99962 11.9366H17.9996C18.5171 11.9366 19 12.0175 19 11.5C19 10.9825 18.5171 11.0616 17.9996 11.0616ZM14.2496 17.0616H9.70988C9.19238 17.0616 8.5 16.9825 8.5 17.5C8.5 18.0175 9.19238 17.9366 9.70988 17.9366H14.2496C14.7671 17.9366 15.5 18.0175 15.5 17.5C15.5 16.9825 14.7671 17.0616 14.2496 17.0616Z",
			fill: "black"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_4125_13973",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgBreakdown;
